<template>
  <div>
    <div class="section-header">
      <div class="section-headers">Habit Program</div>
      <copy :habitProgram="theme" id="copy-habit-program" />
    </div>
    <edit-habit-program :aof="theme" @saved="save"/>

    <div class="section" id="areas-of-focus">
      <div class="section-header">
        <div class="section-headers">Areas of Focus</div>
         <h-btn @click="newAreaOfFocus" v-if="theme.company">
           Add Area Of Focus
         </h-btn>
      </div>
      <div class="card-rows">
        <div 
          class="card card--white " 
          v-for="areaOfFocus in areasOfFocus" :key="areaOfFocus.id">
          <div class="card--container row space-between">
            <div class="clickable"  @click="editAreaOfFocus(areaOfFocus)" >{{areaOfFocus.name}}</div>
            <h-icon class="clickable" @click="deleteAreaOfFocus(areaOfFocus)">delete</h-icon>
          </div>
        </div>
      </div>
      <div class="card card--white" v-if="areasOfFocus.length == 0">
        <div class="card--container">
          This program doesn't have an area of focus yet.
        </div>
      </div>
      <exercise-list :editable="user.id == theme.owner" :areasOfFocus="areasOfFocus" :habitProgramId="id" :canCreate="areasOfFocus.length > 0" :userId="user.id"/>
      <modal 
        v-if="newAoF" 
        @close="newAoF=false" 
        btn="Save" 
        title="New Area of Focus"
        @submit="createNewArea(newArea)"
        :disabled="busy">
        <h-input v-model="newArea.name" label='Name' required />
        <div class="input">
          <div class="label">Exercises and charts linked to this focus will be displayed using this color</div>
          <swatches class="full-width" :value="newArea.color" @input="h => newArea.color = h.hex" />
        </div>
        
        <h-input v-model="newArea.public" :reverse="true" type="checkbox" label="Allow clients to receive exercises in this area" />
      </modal>
    </div>
  </div>
</template>

<script>
import dataStore from "@/services/api/store";
import client from "../../components/clients";
import editHabitProgram from "../edit";
import User from "@/services/api/authUser";
import copy from "./copy_modal";
import modal from "@/components/modal/default";
import snackbar from "@/services/hubs/snackbar";
import exerciseList from "./exerciseList";
import { Swatches } from "vue-color";

export default {
  props: ["id"],
  data() {
    return {
      user: User,
      dialog: true,
      theme: {},
      areasOfFocus: [],
      busy: false,
      newAoF: false,
      newArea: {
        color: ""
      },
      clients: [],
      findingClients: false
    };
  },
  created() {
    dataStore.find("CoachHabitPrograms", this.id).then(result => {
      this.theme = result;
    });

    dataStore.findAll("CoachAreaOfFocus", {limit: 100, 'theme': this.id }, {force: true})
      .then(r => {
        this.areasOfFocus = r;
      })
  },
  methods: {
    save() {
      this.theme.save().then(() => {
        snackbar.update("Saved");
      });
    },
    newAreaOfFocus() {
      this.newAoF = true;
      this.newArea = { color: "" };
    },
    editAreaOfFocus(areaOfFocus) {
      this.newArea = areaOfFocus;
      this.newAoF = true;
    },
    deleteAreaOfFocus(areaOfFocus) {
      areaOfFocus.destroy()
      this.areasOfFocus = this.areasOfFocus.filter(a => a !== areaOfFocus)
      snackbar.update("deleted")
    },
    createNewArea(newArea) {
      this.busy = true;
      // required?
      newArea.areas_of_focus = [this.$route.params.id];
      if (newArea.id) {
        this.newArea.save()
        .then(() => {
          this.newAoF = false;
          snackbar.update("Saved");
        })
        .finally(() => this.busy = false );
        return;
      }

      dataStore.create("CoachAreaOfFocus", newArea).then((r) => {
        this.busy = false;
        this.newAoF = false;
        this.areasOfFocus = [r, ...this.areasOfFocus];
      });
    },
  },
  components: {
    editHabitProgram,
    client,
    copy,
    modal,
    Swatches,
    exerciseList
  }
};
</script>